module.exports = __webpack_public_path__ + "6e28ea0f934c930376c25920c549f578.png";